import React from 'react';
import { CheckIcon, CreditCardIcon, LockIcon, MailIcon } from 'lucide-react';
import { Eyebrow } from './ui/Eyebrow';
import { CtaButton } from './ui/CtaButton';
import { CountdownClock } from './CountdownClock';
import { offerIncludes } from '../data/content';
export function OfferSection() {
  return <section id="comprar" className="border-b border-line bg-cream" data-id="element-140" data-mp="deexww0j53sl">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-24" data-id="element-141" data-mp="id8dctzdn4ve">
        <div className="grid gap-12 lg:grid-cols-[0.95fr_1.05fr] lg:gap-16" data-id="element-142" data-mp="icor512p1ubk">
          <div data-id="element-143" data-mp="mdsa3wg1g6h0">
            <Eyebrow data-id="element-144" data-mp="md8oo5r6izy8">Oferta por tiempo limitado</Eyebrow>
            <h2 className="mt-4 font-condensed text-4xl uppercase leading-[0.95] tracking-tight text-ink sm:text-5xl" data-id="element-145" data-mp="rdemk3o1lior">
              La promo de 60% off vence en
            </h2>
            <p className="mt-4 max-w-prose text-[15px] leading-relaxed text-ink-soft" data-id="element-146" data-mp="2t59inaxtfelv">
              Este precio termina esta noche. Después, el pack vuelve a su precio habitual.
            </p>

            <div className="mt-8" data-id="element-147" data-mp="2y67888l5naxe">
              <CountdownClock data-id="element-148" data-mp="12ns215ktocxl" />
            </div>

            <div className="mt-10 max-w-md" data-id="element-149" data-mp="12plckvyk3hav">
              <div className="flex items-baseline justify-between text-[11px] font-semibold uppercase tracking-eyebrow" data-id="element-150" data-mp="xwjs88fkypjw">
                <span className="text-ink-soft" data-id="element-151" data-mp="syibvv9jh4c4">Disponibilidad limitada — solo hoy</span>
                <span className="text-accent" data-id="element-152" data-mp="ox53bdf2an1i">68% reservado</span>
              </div>
              <div className="mt-3 h-2 overflow-hidden rounded-full bg-sand" role="progressbar" aria-valuenow={68} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos reservados" data-id="element-153" data-mp="1lmmhyhw0vjfc">
                <div className="h-full w-[68%] rounded-full bg-amber" data-id="element-154" data-mp="1clg1u9xacamm" />
              </div>
            </div>
          </div>

          <article className="rounded-2xl border border-ink/10 bg-paper p-8 shadow-lift sm:p-10" data-id="element-155" data-mp="17ljv42x7e53d">
            <p className="text-[11px] font-semibold uppercase tracking-eyebrow text-ink-mute" data-id="element-156" data-mp="17kisq39fhq4">
              El Profe de Guitarra — El pack completo «Supervivencia del profe»
            </p>
            <h3 className="mt-4 font-display text-3xl font-semibold leading-tight text-ink" data-id="element-157" data-mp="3ttq24lczy7ii">
              6 volúmenes + 6 bonos gratis
            </h3>

            <h4 className="mt-8 text-[11px] font-semibold uppercase tracking-eyebrow text-accent" data-id="element-158" data-mp="2lc6drvw2pg4">
              Qué incluye
            </h4>
            <ul className="mt-4 space-y-3" data-id="element-159" data-mp="3ou52s9twzx59">
              {offerIncludes.map(item => <li key={item} className="flex items-start gap-3 text-[15px] text-ink" data-id="element-160" data-mp="3b3i3afgby384">
                  <CheckIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-accent" data-id="element-161" data-mp="3b1ot4q6id0vd" />
                  <span data-id="element-162" data-mp="3fw1hnemud2dz">{item}</span>
                </li>)}
            </ul>

            <div className="mt-8 border-t border-line pt-6" data-id="element-163" data-mp="3175adjslztef">
              <p className="text-[11px] font-semibold uppercase tracking-eyebrow text-ink-mute" data-id="element-164" data-mp="363ncsd0gvfnl">
                Valor real total: $745.000
              </p>
              <div className="mt-3 flex flex-wrap items-baseline gap-4" data-id="element-165" data-mp="2s702z9nf0v09">
                <span className="font-display text-5xl font-semibold leading-none text-ink sm:text-6xl" data-id="element-166" data-mp="2x37cfcf0somy">
                  $27.990
                </span>
                <span className="font-display text-2xl text-ink-mute line-through" data-id="element-167" data-mp="28jdn90rprxv0">$745.000</span>
              </div>
              <p className="mt-4 inline-block rounded-full bg-accent-soft px-3 py-1.5 text-[12px] font-semibold uppercase tracking-wide text-accent-dark" data-id="element-168" data-mp="2mjog29cl3mit">
                Ahorrás $717.010 — 96% de descuento
              </p>
              <p className="mt-3 text-[11px] font-semibold uppercase tracking-eyebrow text-ink-mute" data-id="element-169" data-mp="2wf8assfewf5z">
                Pago único · Acceso de por vida
              </p>
            </div>

            <div className="mt-8" data-id="element-170" data-mp="365b1glz29h15">
              <CtaButton data-id="element-171" data-mp="368fca2717b0s">Dame el pack completo ahora</CtaButton>
              <p className="mt-3 text-center text-xs text-ink-mute" data-id="element-172" data-mp="318uazl4e2qkw">
                Protegido por nuestra garantía de 7 días.
              </p>
            </div>

            <ul className="mt-8 grid gap-3 border-t border-line pt-6 text-xs text-ink-mute sm:grid-cols-3" data-id="element-173" data-mp="3a8hce6x4bwdy">
              <li className="flex items-center gap-2" data-id="element-174" data-mp="18jjv9bmjw5qh">
                <LockIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-175" data-mp="18gxqfjr1o4by" />
                Pago seguro
              </li>
              <li className="flex items-center gap-2" data-id="element-176" data-mp="1i8toiut4rug6">
                <MailIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-177" data-mp="1i9d9kke2uyyf" />
                PDFs a tu email
              </li>
              <li className="flex items-center gap-2" data-id="element-178" data-mp="1mcjb5eq8w1yk">
                <CreditCardIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-179" data-mp="pl7nnubaf3x0" />
                Tarjeta · Google Pay · Apple Pay
              </li>
            </ul>
          </article>
        </div>
      </div>
    </section>;
}